import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reassurance } from './Reassurance';
import { CHECKOUT_URL } from '../data/content';
const incluye = ['6 tomos de la Enciclopedia', '5 bonus estratégicos', 'Protocolo inicial de 9 días', 'Plan Maestro de 30 días'];
export function PriceSection() {
  return <section id="precio" className="w-full scroll-mt-4 bg-brand-deep px-4 py-12 sm:px-6 sm:py-20" data-id="element-92" data-mp="35etc1h0naap8">
      <div className="mx-auto max-w-xl" data-id="element-93" data-mp="2viq2vr7dlbss">
        <div className="overflow-hidden rounded-3xl border border-accent/40 bg-white/[0.07] shadow-2xl shadow-black/30" data-id="element-94" data-mp="2vhotrs9x6zdp">
          <div className="bg-accent px-4 py-2.5 text-center" data-id="element-95" data-mp="2qjx0attmn57e">
            <p className="font-display text-[0.7rem] font-extrabold uppercase tracking-widest text-white sm:text-xs" data-id="element-96" data-mp="2mitmecv53j8t">
              Oferta de lanzamiento · Solo por hoy
            </p>
          </div>

          <div className="px-5 py-8 text-center sm:px-8 sm:py-10" data-id="element-97" data-mp="kqf1r617o0op">
            <p className="font-display text-xs font-extrabold uppercase tracking-wider text-violet-300 sm:text-sm" data-id="element-98" data-mp="1mim10q6uil67">
              Valor real del programa completo
            </p>
            <p className="mt-1 font-display text-3xl font-extrabold text-violet-300/70 line-through sm:text-4xl" data-id="element-99" data-mp="1rfm6ozzs9lws">
              $157 USD
            </p>
            <p className="mt-2 text-xs text-violet-200 sm:text-sm" data-id="element-100" data-mp="1hkkh631lihto">
              6 tomos ($97) + 5 bonus ($60)
            </p>

            <div className="mx-auto my-7 h-px w-24 bg-white/20" data-id="element-101" data-mp="259vm7wpzaydm" />

            <p className="font-display text-sm font-extrabold uppercase tracking-wider text-white sm:text-base" data-id="element-102" data-mp="2a8gf1b2wifs1">
              Precio especial de lanzamiento hoy
            </p>
            <p className="mt-1 font-display text-[4rem] font-black leading-none text-white sm:text-7xl" data-id="element-103" data-mp="20i54h5opp8c6">
              $17
              <span className="align-top text-xl font-extrabold sm:text-3xl" data-id="element-104" data-mp="2o6wt5n33f8k7">
                {' '}
                USD
              </span>
            </p>

            <p className="mx-auto mt-4 inline-block rounded-full bg-amber-400 px-4 py-2 font-display text-[0.8rem] font-extrabold uppercase tracking-wide text-brand-deep sm:mt-5 sm:px-5 sm:text-base" data-id="element-105" data-mp="32uogfnzdf82a">
              Ahorras $140 USD comprando hoy
            </p>

            <ul className="mx-auto mt-7 grid max-w-sm gap-2 text-left sm:grid-cols-2" data-id="element-106" data-mp="2tsf894rkrqs2">
              {incluye.map(item => <li key={item} className="flex items-start gap-2 text-[0.85rem] leading-snug text-violet-100 sm:text-sm" data-id="element-107" data-mp="2ox9l62mfs62e">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-108" data-mp="2f3ssj1y1cx0b" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 sm:mt-8" data-id="element-109" data-mp="215b75avlrwlk">
              <CtaButton href={CHECKOUT_URL} external location="precio" data-id="element-110" data-mp="213zusmo3dgiu">
                ¡Sí, quiero reiniciar mi metabolismo ahora!
              </CtaButton>
            </div>

            <Reassurance className="mt-4" tone="dark" items={['Un solo pago', 'Acceso inmediato', 'Acceso de por vida', '100% digital', 'Sin suscripciones']} data-id="element-111" data-mp="1m32rz2f5fr3j" />
          </div>
        </div>
      </div>
    </section>;
}